<template>
  <div class="bg-[#FFFFFF]">
    <div
      class="w-100 bg-[#F8F8F8] border border-2 px-1 py-[1.2rem] rounded-t-xl font-semibold text-black"
    >
      Ringkasan Info
    </div>
    <div class="p-1 border border-2 rounded-b-xl text-black h-[10rem] overflow-auto">
      <BRow class="my-2 align-self-center">
        <BCol
          cols="5"
          class="align-self-center"
        >
          Nama Bisnis
        </BCol>
        <BCol
          cols="7"
          class="text-black font-semibold"
        >
          : {{ ["", null].includes(brandName) ? "-" : brandName }}
        </BCol>
      </BRow>
      <BRow class="my-2 align-self-center">
        <BCol
          cols="5"
          class="align-self-center"
        >
          Saldo Terupdate
        </BCol>
        <BCol
          cols="7"
          class="font-semibold d-flex"
        >
          <div class="align-self-center">
            <span>: </span>
            <span class="text-[#F95031]">{{ IDR(kmpoin) }}</span>
          </div>
          <span v-if="financeMenu.topupMenu">
            <span
              id="private-btn"
              class="k-money-change ml-1 text-primary text-3xl cursor-pointer"
            />
            <b-popover
              target="private-btn"
              triggers="click"
              placement="right"
              custom-class="w-64"
            >
              <button
                class="btn"
                @click="setActionModal('Top Up Saldo')"
              >
                Top Up Saldo
              </button>
              <button
                class="btn"
                @click="setActionModal('Pengurangan Saldo')"
              >
                Pengurangan Saldo
              </button>
              <button
                class="btn"
                :disabled="financeMenu.transferSaldo"
                @click="setActionModal('Transfer Saldo')"
              >
                Transfer Saldo
              </button>
            </b-popover>
          </span>
        </BCol>
      </BRow>
    </div>
    <ModalPrivate
      :modal-value="modalValue"
      @on-confirm-button="openTotpModal"
    />
    <ModalTOTP
      id="modal-totp-summary"
      ref="modalTotp"
      @submit="submitTotp"
      @hidden="resetModalValue"
    />
  </div>
</template>

<style scoped>
@media screen and (min-width: 1280px) {
  .text-truncate {
    max-width: 280px;
  }
}
</style>

<script>
import { IDR } from '@/libs/currency'
import { newAxiosIns } from '@/libs/axios'
import ModalTOTP from '@/views/components/modal/ModalTOTP.vue'
import { handleDefaultResponse } from '@/views/components/modal/modalTOTPUtils'
import ModalPrivate from './ModalPrivate.vue'

export default {
  components: {
    ModalPrivate,
    ModalTOTP,
  },
  props: {
    brandName: {
      type: String,
      default: null,
    },
    kmpoin: {
      type: Number,
      default: 0,
    },
    financeMenu: {
      type: Object,
      default: () => ({
        topupMenu: false,
        transferSaldo: false,
      }),
    },
    modalValue: {
      type: Object,
      default: () => {},
    },
    getDetail: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      IDR,
      totpAttempts: 0,
    }
  },
  methods: {
    setActionModal(value) {
      this.resetModalValue()
      this.$root.$emit('bv::hide::popover', 'private-btn')
      this.modalValue.titleModal = value
      this.modalValue.subTitle = value
      if (this.modalValue.titleModal === 'Top Up Saldo') {
        this.modalValue.type = 'TopupManual'
        this.modalValue.placeholderNotes = 'Top up Rp xx.xxx untuk keperluan ganti rugi paket hilang/rusak'
        this.$bvModal.show('modal-private-action')
      } else if (this.modalValue.titleModal === 'Pengurangan Saldo') {
        this.modalValue.type = 'BalanceReduction'
        this.modalValue.placeholderNotes = 'Pengurangan saldo sebesar Rp xx.xxx untuk transaksi xyz'
        this.$bvModal.show('modal-private-action')
      } else if (
        this.modalValue.titleModal === 'Transfer Saldo'
        && !this.financeMenu.transferSaldo
      ) {
        this.modalValue.subTitle = 'Pengurangan Saldo'
        this.modalValue.type = 'TransferSaldo'
        this.modalValue.emailRequired = true
        this.modalValue.placeholderNotes = 'Pemindahan dana Rp xx.xxx dari putri1@gmail.com ke putri2@gmail.com'
        this.modalValue.email = ''
        this.$bvModal.show('modal-private-action')
      }
      this.modalValue.kmpoin = this.kmpoin
    },
    openTotpModal() {
      this.totpAttempts = 0
      this.$refs.modalTotp.show()
    },
    resetModalValue() {
      this.modalValue.notes = ''
      this.modalValue.email = ''
      this.modalValue.nominal = 0
      this.modalValue.emailRequired = false
    },
    // Verify TOTP and execute balance mutation (topup/deduct/transfer)
    async submitTotp(otpCode, helpers) {
      this.totpAttempts += 1
      if (helpers) helpers.setLoading(true)

      let textToast = ''
      let url = ''
      const userId = this.modalValue.user_id || this.$route.params.id

      const body = {
        code: otpCode,
        nominal: this.modalValue.nominal,
        notes: this.modalValue.notes,
      }

      // Determine endpoint and toast message based on transaction type
      if (this.modalValue.type === 'TopupManual') {
        textToast = 'Berhasil menambahkan saldo user'
        url = 'topup'
      } else if (this.modalValue.type === 'BalanceReduction') {
        textToast = 'Berhasil mengurangi saldo user'
        url = 'deduct'
      } else if (this.modalValue.type === 'TransferSaldo') {
        textToast = 'Berhasil mentransfer saldo user'
        url = 'transfer'
        body.email = this.modalValue.email
      }

      const endpoint = `/auth/api/v1/admin/user/${userId}/${url}`

      try {
        await newAxiosIns.post(endpoint, body)
        this.$toast_success({ message: textToast })
        if (helpers) helpers.hide()
        this.totpAttempts = 0
        this.resetModalValue()
        this.$emit('update-user-data')
      } catch (error) {
        if (helpers) helpers.setLoading(false)
        const { message, code } = error.response?.data?.meta || {}

        handleDefaultResponse({
          status: code || error.response?.status,
          metaMessage: message || 'Gagal memproses transaksi',
          helpers,
          totpAttempts: this.totpAttempts,
          toast: this.$toast,
        })
      }
    },
  },
}
</script>
